var React = require('react');

function IconLocktime (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"그룹_1466"},[React.createElement("path",{"id":"패스_759","d":"M6.211 21.727V10.818h13.263v1.091a7.729 7.729 0 0 1 2.211.316v-1.407a2.2 2.2 0 0 0-2.211-2.182h-1.106V6.455a5.527 5.527 0 0 0-11.053 0v2.181H6.211A2.2 2.2 0 0 0 4 10.818v10.909a2.2 2.2 0 0 0 2.211 2.182h6.919a7.739 7.739 0 0 1-1.072-2.182zM9.526 6.455a3.316 3.316 0 0 1 6.632 0v2.181H9.526z","className":"cls-1","transform":"translate(-4 -1)","key":0}),React.createElement("path",{"id":"패스_760","d":"M18.526 13a5.455 5.455 0 1 0 5.526 5.455A5.493 5.493 0 0 0 18.526 13zm1.824 8.018l-2.376-2.345v-3.491h1.105v3.044l2.045 2.018z","className":"cls-1","transform":"translate(-3.053 .091)","key":1})]));
}

IconLocktime.defaultProps = {"id":"icon_locktime","width":"21","height":"24","viewBox":"0 0 21 24"};

module.exports = IconLocktime;

IconLocktime.default = IconLocktime;
